import script from "./FilePreviewIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./FilePreviewIcon.vue?vue&type=script&setup=true&lang=js"

import "./FilePreviewIcon.vue?vue&type=style&index=0&id=1d045bdf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d045bdf"]])

export default __exports__